import React, { useState, useEffect } from 'react';
import { Header, Footer } from '../../Container';
import { Container, Col, Button, ListGroup, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../../../assets/css/Cogen.css';
import { ReqGet } from '../../../config/Requests';
import { useLocation } from 'react-router-dom';

function FAQs() {
	const profile = JSON.parse(localStorage.getItem('cogen_user_profile'));
	const navigate = useNavigate();
	const [dataList, setDataList] = useState([]);
	const id = window.location.href.split('/').reverse()[1];

	const [request, setRequest] = useState({
		isInitiated: false,
		isSuccess: false,
		isFailed: false,
	});

	useEffect(() => {
		setRequest({ isInitiated: true });
		ReqGet(`job/${id}/faqs`)
			.then(res => {
				setDataList(res.data);
				console.log(res.data);
				setRequest({ isInitiated: false, isSuccess: true });
			})
			.catch(err => console.log(err.response));
		setRequest({ isSuccess: false, isFailed: true });
	}, []);

	const location = useLocation();
	const { title, desc } = location.state.params;

	return (
		<Container fluid='true'>
			<Header type='member' />
			<Container className='flex-column mt-5 notification align-content-inherit'>
				<Col md='auto'>
					<Button
						className='btn_cancel'
						variant='primary'
						onClick={() => navigate('/')}
					>
						Back{' '}
					</Button>
				</Col>
				<Col className='p-0'>
					<Card className='mt-3 mb-2 job-view'>
						<Card.Body>
							<Card.Title className='text-primary normal p-1 fw-bold'>
								{title}
							</Card.Title>
							<Card.Text className='text-job-large fw-bold'>
								Description:
							</Card.Text>
							<Card.Text className='text-job-large mb-4'>
								<p>{desc}</p>
							</Card.Text>
						</Card.Body>
					</Card>
				</Col>
				<div className='wrapper'>
					<br /> <br />
					<h5 className='title'>Questions asked related to this job</h5>
					<br />
				</div>
				<div className='wrapper'>
					<br />
					<ListGroup>
						{dataList.length === 0 && request.isSuccess === true ? (
							<ListGroup.Item>
								No Question is asked related to this job
							</ListGroup.Item>
						) : (
							dataList.map((item, i) => {
								return (
									<div key={i}>
										<h6 className='title'>
											Questions asked by member with its ID
										</h6>
										<Container style={{ width: '80%', display: 'block' }}>
											{item.map((threads, index) => {
												if (profile.id === threads.participable_id) {
													return (
														<Col key={index}>
															<ListGroup.Item>
																<strong>Me:</strong> {threads.body}
															</ListGroup.Item>
														</Col>
													);
												} else {
													return (
														<Col key={index}>
															<ListGroup.Item>
																<strong>{threads.public_id}:</strong>
																{threads.body}
															</ListGroup.Item>
														</Col>
													);
												}
											})}
										</Container>
									</div>
								);
							})
						)}
					</ListGroup>
					<br />
				</div>
			</Container>
			<Footer />
		</Container>
	);
}

export default FAQs;
